import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Password.module.css'     
import Lock from "../../../../assets/Icon/Lock";  
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

const UserEditModal = ({ userService, defaultUser }) => {
    const {t} = useTranslation();
    
    const userResetData = {
        id: 0, 
        password: "", 
        password_confirm: "",
    }

    const initEditUser = (user) => {
        return {
            id: user.id, 
            password: "",  
            password_confirm: "",
        }
    }


    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };

    const [newUser, setNewUser] = useState(userResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);
    const roles = appState.roles.map((role) => ({ value: role.id, label: role.name }));


    const validateUser = (user) => {
        const messages = {};
    
        if (user.password.length < 2) {
            messages.password = { message: t('Password6CharsMinimum'), isValid: false };
        }

        if (user.password_confirm.length < 2) {
            messages.password_confirm = { message: t('ConfirmPassword'), isValid: false };
        }
        
        if (user.password !== user.password_confirm && user.password.length > 0 && user.password_confirm.length > 0) {
            messages.password = { message: t('PasswordMismatch'), isValid: false };
        }
  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateUser(newUser)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateUser(newUser)
        }
      }, [newUser, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditUser(defaultUser)
         setNewUser(editedCar)
    }, [defaultUser]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateUser(newUser)

        if (isValidate === true) {
            userService.updatePassword(newUser)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    const setIsAdmin = (isAdmin) => {
        setNewUser(prevClient => ({
            ...prevClient,
            is_admin: isAdmin
        }));
    }

  
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Lock/> {t('Password')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

            
                <div className={cl.modalHead} >
                    <h3>
                    <span className={cl.iconHead} > <Lock /></span> {t('Password')}
                    </h3>
                </div>
  
                    
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" className={cl.input} placeholder={t('Password')} name="password" value={newUser.password} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <Lock/>
                            </div>
                        </div>
                        {validates && validates.password &&
                            <div className={ cl.errorMsg } >{validates.password.message}</div>}
                    </div> 
    
 
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" className={cl.input} placeholder={t('ConfirmPassword')} name="password_confirm" value={newUser.password_confirm} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <Lock/>
                            </div>
                        </div>
                        {validates && validates.password_confirm &&
                            <div className={ cl.errorMsg } >{validates.password_confirm.message}</div>}
                    </div> 


                 
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span> 
            </Modal>
        </div>
    );
};

export default UserEditModal;